import { useLocation, useNavigate } from "react-router-dom";
import Tabs from "./Tabs";

const TabsNavigation = ({ children,tabRoutes,title="" }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeIndex = tabRoutes.findIndex((tab) => location.pathname === tab.path);

  return (
    <div className="flex flex-col">
      <div className="font-normal text-lg xl:text-3xl text-primary mb-8">
          {title}
        </div>
      <Tabs 
        items={tabRoutes} 
        selectedIndex={activeIndex} 
        setSelectedIndex={(i) => navigate(tabRoutes[i].path)} 
      />
      <div className="mt-4 flex-grow">{children}</div>
    </div>
  );
};

export default TabsNavigation;
